<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import removalMethodEnum from '../enums/removalMethod'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                inspectionForm: () => import('../forms/InspectionForm'),
                fileForm: () => import('../forms/FileForm'),
                fields: [
                    { type: 'datetime', text: 'On', value: 'on', rules: [v => !!v || 'On is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Inspection', value: 'inspectionId', rules: [v => !!v || 'Inspection is required'], isRequired: true, form: () => import('./InspectionForm'), apiMethod: 'Inspections', claim: 'Inspections' },
                    { type: 'enum', text: 'Removal Method', value: 'removalMethod', rules: [v => (v !== null && v !== '') || 'Removal Method is required'], isRequired: true, items: enumService.enumAsSelectList(removalMethodEnum) },
                    { type: 'number', text: 'Number Of Hives', value: 'numberOfHives', rules: [v => (v !== null && v !== '') || 'Number Of Hives is required'], isRequired: true },
                    { type: 'file', text: 'Proof Of Mitigation File', value: 'proofOfMitigationFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                ],
                apiMethod: 'HiveRemovals',
                formTitle: 'Hive Removal',
            }
        },
    };
</script>
